export default __webpack_public_path__ + "static/insect-based-dog-food-5-32228b2ea17e5f6b9f2ec1450727439e.jpg";